module.exports = __webpack_public_path__ + "static/header-logo-3eeed470a8f18861d1a5777c77e3ab45.png";